import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';

import type { AvailableAppointment } from './types';

const getAvailableAppointments = async (pincode: string) => {
  if (!pincode) {
    return null;
  }

  return axios<
    AvailableAppointment[],
    BaseResponse<AvailableAppointment[]>,
    void
  >({
    url: '/appointments',
    method: 'get',
    params: { pinCode: pincode },
  });
};

export const useAvailableAppointments = (pincode: string) => {
  const [availableAppointments, setAvailableAppointments] = useState<
    AvailableAppointment[]
  >([]);

  const { data, isLoading } = useQuery({
    queryKey: ['available-appointments', pincode],
    queryFn: () => getAvailableAppointments(pincode),
    useErrorBoundary: false,
    refetchOnWindowFocus: true,
    retry: 3,
    enabled: !!pincode,
  });

  useEffect(() => {
    const resultData = data?.data.data;
    const newAvailableAppointments = Array.isArray(resultData)
      ? resultData
      : [];
    setAvailableAppointments(newAvailableAppointments);
  }, [data]);

  return {
    availableAppointments,
    isLoading,
  };
};
